export default {"src":"/_next/static/media/pci.ead094f8.svg","height":188,"width":303,"blurWidth":0,"blurHeight":0};